// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3Nu2A","title":"ClientCherryInfo_title__qxiei","itemText":"ClientCherryInfo_itemText__3VuMa"};